@if(hasMaxDate){
<mat-form-field [class]="classStyle ?? 'form-design-ui'" [ngClass]="ngClassStyle" [appearance]="appearance ?? 'fill'" [floatLabel]="floatLabel">
  @if(showLabel){
  <mat-label class="automtic-form-desing-lable" [ngClass]="{}">
    <span [class]="labelClass">
      {{ title }}
    </span>
    <!-- <span *ngIf="isRequired" class="automtic-form-desing-required-sign"> * </span> --> </mat-label
  >} @if(prefixIcon){
  <mat-datepicker-toggle matPrefix [for]="dp3">
    <span
      matDatepickerToggleIcon
      class="material-icons material-symbols-outlined material-icons-outlined"
      [ngClass]="{
        'text-k-blue': !disabled,
        'text-k-grey': disabled
      }"
      >calendar_today</span
    >
  </mat-datepicker-toggle>
  }
  <input
    #input
    matInput
    [max]="maxDate"
    [min]="min"
    [matDatepicker]="dp3"
    (click)="dp3.open(); input.focus()"
    (dblclick)="input.focus()"
    [formControlName]="controlName"
    (dateChange)="setDateChange($event.value)"
    (change)="handleDateChange($event)"
    [value]="value"
    [placeholder]="placeholder"
    (keydown)="input.focus()"
    (keypress)="input.focus(); restrictToNumbers($event)"
    [required]="isRequired"
    [disabled]="disabled"
  />
  <!-- {{ input.focus() }} -->
  @if(!prefixIcon){
  <mat-datepicker-toggle matSuffix [for]="dp3"> </mat-datepicker-toggle>
  }
  <mat-datepicker #dp3 disabled="false"></mat-datepicker>
  <mat-error *ngIf="hasError">{{ error }}</mat-error>
</mat-form-field>
}@else{

<mat-form-field
  style="width: 100% !important; height: 57.6px; margin-top: 0px"
  [class]="classStyle ?? 'form-design-ui'"
  [ngClass]="ngClassStyle"
  [appearance]="appearance ?? 'fill'"
  [floatLabel]="floatLabel"
>
  <mat-label class="automtic-form-desing-lable" [ngClass]="{}">
    <span [class]="labelClass">{{ title }} </span>
    <!-- <span *ngIf="isRequired" class="automtic-form-desing-required-sign"> * </span> -->
  </mat-label>
  <input
    #input
    [min]="min"
    matInput
    [matDatepicker]="dp3"
    (click)="dp3.open(); input.focus()"
    (dblclick)="input.focus()"
    [formControlName]="controlName"
    (dateChange)="setDateChange($event.value)"
    (change)="handleDateChange($event)"
    [value]="value"
    [placeholder]="placeholder"
    (keydown)="input.focus()"
    (keypress)="input.focus(); restrictToNumbers($event)"
    [required]="isRequired"
    [disabled]="disabled"
  />
  <!-- {{ input.focus() }} -->
  <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
  <mat-datepicker #dp3 disabled="false"></mat-datepicker>
  <mat-error *ngIf="hasError">{{ error }}</mat-error>
</mat-form-field>

}
